import request from '@/utils/request'


// 查询发现-话题管理列表
export function listDiscoveryTopic(query) {
  return request({
    url: '/discovery/discovery/topic/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现-话题管理分页
export function pageDiscoveryTopic(query) {
  return request({
    url: '/discovery/discovery/topic/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现-话题管理详细
export function getDiscoveryTopic(data) {
  return request({
    url: '/discovery/discovery/topic/detail',
    method: 'get',
    params: data
  })
}

// 新增发现-话题管理
export function addDiscoveryTopic(data) {
  return request({
    url: '/discovery/discovery/topic/add',
    method: 'post',
    data: data
  })
}

// 修改发现-话题管理
export function updateDiscoveryTopic(data) {
  return request({
    url: '/discovery/discovery/topic/edit',
    method: 'post',
    data: data
  })
}

// 删除发现-话题管理
export function delDiscoveryTopic(data) {
  return request({
    url: '/discovery/discovery/topic/delete',
    method: 'post',
    data: data
  })
}
